import React, {useContext} from 'react';

import Link from '~/src/components/link/Link';
import {TeaserLayoutProps} from '~/src/components/teaser/layout/default/TeaserLayoutDefault';

import {SettingsContext} from '~/src/components/context/SettingsContext';
import {classNames} from '~/src/utilities/helpers/css';
import {createNavigationTracker} from '~/src/utilities/tracking/gtm';
import {getCategoryUrl} from '~/src/utilities/helpers/link';

import css from './TeaserLayoutEditorsPick.module.scss';

const TeaserLayoutEditorsPick = ({colorScheme, icon, title, showTitle, pointerCategoryID, fullUrlPath, children}: TeaserLayoutProps) => {
    const {siteArea} = useContext(SettingsContext);
    const classes = classNames(css, 'topList', siteArea, colorScheme);

    const childrenWithNoAds = children.filter((element) => element.props.type !== 'ad');
    const ads = children.filter((element) => element.props.type === 'ad');

    return (
        <React.Fragment>
            <div className={classes}>
                <div className={css.titleHeader}>
                    {icon?.variants.original && (
                        <div className={css.icon}>
                            <img src={icon.variants.original.src} alt="editorIcon" />
                            <div className={css.backline}></div>
                        </div>
                    )}
                    {showTitle && (
                        <h1 className={css.title}>
                            {fullUrlPath ? (
                                <Link
                                    className={css.titleLink}
                                    href={getCategoryUrl(fullUrlPath)}
                                    onClick={pointerCategoryID ? createNavigationTracker(4, title, pointerCategoryID) : null}
                                >
                                    {title}
                                </Link>
                            ) : (
                                title
                            )}
                        </h1>
                    )}
                </div>
                <div className={css.teasers}>{childrenWithNoAds}</div>
            </div>
            <div className={css.ads}>{ads}</div>
        </React.Fragment>
    );
};

export default TeaserLayoutEditorsPick;
